import { Component, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from "../common/sidebar/sidebar.component";
import { NgClass } from '@angular/common';
import { ModalComponent } from "../../../common/modal/modal.component";
import { ModalsService } from '../../../services/modals/modals.service';
import { ToastComponent } from '../../../common/toast/toast.component';
import { ToastService } from '../../../services/toast/toast.service';
import { SidebarService } from '../../../services/sidebar/sidebar.service';


@Component({
  selector: 'admin-template',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, NgClass, ModalComponent, ToastComponent ],
  templateUrl: './template.component.html',
  styleUrl: './template.component.scss'
})
export class TemplateComponent {
  @ViewChild('modals',{static: true}) modalsComponent!: ModalComponent;
  @ViewChild('toasts',{static: true}) toastComponent!: ToastComponent;

  constructor(
    private modals: ModalsService,
    private toast: ToastService,
    public sidebar: SidebarService,
  ){}

  ngOnInit(){
    this.modals.bindComponent(this.modalsComponent);
    this.toast.bindComponent(this.toastComponent);
    this.sidebar.show();
  }
}
